<template>
<div>
  
      <!-- /.row -->
      <div class="modal fade" id="newModal">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header">
              <h4 v-show="!editMode" class="modal-title">Add New</h4>
              <h4 v-show="editMode" class="modal-title">Update Details</h4>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->



  <section class="content">

      <!-- Default box -->
      <div class="box">
        <form @submit.prevent="sendPermission">
        <div class="box-header with-border">
          <h3 class="box-title">Permission List</h3>

          <div class="box-tools pull-right">
            <button type="button" class="btn btn-box-tool" data-widget="collapse" data-toggle="tooltip" title="" data-original-title="Collapse">
              <i class="fa fa-minus"></i></button>
            <button type="button" class="btn btn-box-tool" data-widget="remove" data-toggle="tooltip" title="" data-original-title="Remove">
              <i class="fa fa-times"></i></button>
          </div>
        </div>
        <div class="box-body">
          <div class="form-group" v-if="canAccess('role-view-any')">
            <label
              >Select Role <span class="red">*</span></label
            >
            <select
              v-model="form.role_id"
              name="role_id"
              @change="getRolePermission"
              :class="{
                'is-invalid': form.errors.has('role_id'),
              }"
              required
            >
              <option v-if="!form.role_id" selected value="">
                Select Role
              </option>
              <option
                :value="role.id"
                v-for="role in roles"
                :key="role.id"
              >
                {{ role.name }}
              </option>
            </select>
            <has-error
              :form="form"
              field="role_id"
            ></has-error>
          </div>
          <table class="table table-sm table-bordered table-striped table-hover">
                  <thead>
                    <tr>
                      <th>Sr. No.</th>
                      <th>Permission</th>
                      <th class="hidden-xs">For</th>
                      <th>Description</th>
                      <th>Action</th>

                      <!-- <th v-if="$gate.isAdmin()">Status</th>
                      <th>Image</th>
                      <th v-if="$gate.isAdmin()">Modify</th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(state, index) in states.data" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ state.permission }}</td>
                      <td>{{ state.for }}</td>
                      <td>{{ state.description }}</td>
                      <td>
                        <input v-if="canAccess('role-permission-update')" type="checkbox" v-model="form.status" :value="state.id" name="status">
                      </td>
                    </tr>
                  </tbody>
          </table>
                
        </div>
        <!-- /.box-body -->
        <div class="box-footer">
          List of all Permissions
          <span>
            <button v-if="canAccess('role-permission-update')" type="submit" class="btn btn-success">
              Save Permission
            </button>
          </span>
        </div>
        <!-- /.box-footer-->
        </form>
      </div>
      <!-- /.box -->

    </section>

</div>
</template>

<script>
export default {
  name: 'state',
  data () {
    return {
      editMode: false,
      roles: [],
      rolePermissions: [],
      form: new Form({
        id: '',
        permission: '',
        for: '',
        description: '',
        status: [],
        permissions: [],
        role_id: null
      }),
      states: []
    }
  },

  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    newModal () {
      this.editMode = false
      this.form.errors.errors = {}
      this.form.reset()
      $('#newModal').modal('show')
    },
    editModal (state) {
      this.editMode = true
      this.form.errors.errors = {}
      this.form.reset()
      $('#newModal').modal('show')
      this.form.fill(state)
    },
    sendPermission () {
      this.form.permissions = this.form.status
      this.$axios
        .post('rolepermission', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreate')
          Toast.fire({
            icon: 'success',
            title: 'Permission Updated Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors = error.response.data.error
          }.bind(this)
        )
    },
    updateState () {
      this.$axios
        .put('state/' + this.form.id, this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'State Details Updated Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    getRolePermission () {
      let loader = this.$loading.show()
      this.$axios
      .get('rolepermission?all=all&status=true&role_id=' + this.form.role_id, {
        headers: { Authorization: 'Bearer ' + localStorage.token }
      })
      .then((response) => response.data)
      .then((data) => {
        this.rolePermissions = data.data
        var dt = []
        for (let i = 0; i < this.rolePermissions.length; i++) {
          // alert(this.rolePermissions[i].permission_id)
          dt.push(this.rolePermissions[i].permission_id)
        }
        loader.hide()
        this.form.status = dt
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    loadRole () {
      this.$axios
        .get('role?all=all', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          this.roles = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    loadData () {
      let loader = this.$loading.show()
      this.$axios
        .get('permission?all=all', {headers: {Authorization: 'Bearer ' + localStorage.token}})
        .then((response) => response.data)
        .then((data) => {
          // console.log(data)
          loader.hide()
          this.states = data
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  created () {
    this.loadRole()
    this.loadData()
    Fire.$on('AfterCreate', () => {
      this.loadData()
    })
  }
}
</script>



// WEBPACK FOOTER //
// Permission.vue?4cef722a